import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";

export interface UploadStockExcelDTO {
  product_id: number;
  warehouse_id: number;
  file: any;
  is_lock: boolean;
}

export type UploadStockExcelResp = BaseResAPI<null>;

const uploadStockExcelInteractor = (
  params: UploadStockExcelDTO
): Promise<UploadStockExcelResp> => {
  const path = "/task/upload-excel";

  const { product_id, warehouse_id, file, is_lock } = params;
  const formData = new FormData();
  formData.append("product_id", `${product_id}`);
  formData.append("warehouse_id", `${warehouse_id}`);
  formData.append("file", file);
  formData.append("is_lock", `${is_lock}`);

  return api.post(path, formData, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

export default uploadStockExcelInteractor;
